import { v4 as uuidv4, validate } from 'uuid';

function getRandomUid() {
  return uuidv4();
}

function isValidUuid(uid) {
  return validate(uid);
}

export { getRandomUid, isValidUuid };
